import Check from '../../Assets/Images/check-white.svg'

export default function Stepper({ steps }) {
  const progress = (steps.current - 1) / (steps.total - 1) * 100;
  const labels = ['Login', 'Profile', 'Payment'];

  return (
    <div className='stepper-container'>
      <div className="stepper-line">
        <div className="stepper-progress" style={{ width: `${progress}%` }}></div>
      </div>
      <div className='steps'>
        {Array.from({ length: steps.total }).map((_, i) => {
          const stepNumber = i + 1;
          const isCompleted = steps.current > stepNumber;
          const isActive = steps.current === stepNumber;
          return (
            <div className="step-wrapper" key={i}>
              {isActive && <div className="step-label">{labels[i]}</div>}
              <div className={`step ${isCompleted ? 'completed' : isActive ? 'active' : ''}`}>
                {isCompleted ? <img src={Check} alt="Completed" /> : stepNumber}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}